import React from 'react'
import FormUpdate from './formUpdate'

const EditDevice = (props) => {
    return (
        <FormUpdate isEdit {...props} />
    )
}

export default EditDevice;
